import React from 'react';

import validate from '../../utilities/control.validate';

const TextareaControl = ({
  submitted = false, classes = 'form-control form-control-sm ',
  value = '', options, onChange, onFocus = () => {}
}) => {
  let { id, label, name, rows = 5, placeholder } = options;

  let inputRequired = false;

  if ( options.rules && options.rules.isRequired ) inputRequired = true;

  let valid = {
    isValid: true,
    validateMessage: ''
  };
  if ( submitted ){
    valid = validate(value, options.rules);
  }

  classes += !valid.isValid ? ' is-invalid' : '';

  return (
    <div className="form-group">
      {
        label &&
        <label htmlFor={id}>
          {label}
          {inputRequired && <span>&nbsp;*</span>}
        </label>
      }
      <textarea
        id={id}
        className={classes}
        name={name}
        value={value}
        placeholder={placeholder}
        rows={rows}
        onChange={onChange}
        onFocus={onFocus}
        required={inputRequired}
      ></textarea>
      {
        valid.validateMessage &&
        <div className="invalid-feedback">{valid.validateMessage}</div>
      }
    </div>
  )
}

export default TextareaControl;
